<template>
  <div id="statusPopup" :class="'status-popup' + (popup_flag ? ' active' : '')">
    <div class="status-popup__bg"></div>
    <div class="status-popup__container">
      <div class="status-popup__title">
        {{ popup_car_number }} Report
      </div>

      <div class="status-popup__close">
        <button type="button" @click="setPopupCloseFlag"></button>
      </div>

      <div class="status-popup__contents">
        <div class="status-popup__contents__icon">
          <img :src="getGradeReportIcon(grade)" alt="Grade">
          <p>
            <span :style="'color: ' + getGradeReportColor(grade)">{{ grade }}</span> Grade
          </p>
        </div>
        <div class="status-popup__contents__box1">
          <h4 class="status-popup__contents__title">Vehicle Evaluation Comparison</h4>
          <section>
            <ul class="desc">
              <li>
                <p>
                  <span>Charge/Discharge SOC Range</span>
                  <b class="warn">Warning</b>
                </p>
              </li>
              <li>
                <p>
                  <span>Route Mileage</span>
                  <b class="safe">Safe</b>
                </p>
              </li>
              <li>
                <p>
                  <span>Route Driving Experience</span>
                  <b class="warn">Warning</b>
                </p>
              </li>
              <li>
                <p>
                  <span>Rapid Accel/Decel Count</span>
                  <b class="care">Caution</b>
                </p>
              </li>
              <li>
                <p>
                  <span>Avg. Battery Module Temp.</span>
                  <b class="warn">Warning</b>
                </p>
              </li>
            </ul>
            <ul class="average">
              <li>Route Avg.</li>
              <li>{{ car_info[0].soc}}</li>
              <li>{{ car_info[0].odo_meter}}</li>
              <li>{{ car_info[0].career}}</li>
              <li>{{ car_info[0].rapid}}</li>
              <li>{{ car_info[0].temperature}}</li>
            </ul>
            <ul class="target">
              <li>{{ popup_car_number }}</li>
              <li>{{ car_info[1].soc}}</li>
              <li>{{ car_info[1].odo_meter}}</li>
              <li>{{ car_info[1].career}}</li>
              <li>{{ car_info[1].rapid}}</li>
              <li>{{ car_info[1].temperature}}</li>
            </ul>
          </section>
        </div>
        <div class="status-popup__contents__box2">
          <h4 class="status-popup__contents__title">Battery Manufacturing Info</h4>
          <div class="status-popup__contents__table">
            <table>
              <colgroup>
                <col style="width: 35%" />
                <col style="width: 65%" />
              </colgroup>
              <tbody>
                <tr>
                  <th>Manufacture Date</th>
                  <td>{{ car_info[2].production_date }}</td>
                </tr>
                <tr>
                  <th>Battery Type</th>
                  <td>{{ car_info[2].bat_type }}</td>
                </tr>
                <tr>
                  <th>Total Capacity (kWh)</th>
                  <td>{{ car_info[2].bat_capacity }}</td>
                </tr>
                <tr>
                  <th>BMS</th>
                  <td>{{ car_info[2].bat_bms }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="status-popup__contents__box3">
          <div class="container" style="width: 100%; height: 100%;">
            <div id="anychart2" ref="anychart2" style="width: 100%; height: 100%;"></div>
          </div>
        </div>
        <div class="status-popup__contents__box4">
          <h4 class="status-popup__contents__title">Battery Status</h4>
          <div class="status-popup__contents__table">
            <table>
              <colgroup>
                <col style="width: 35%" />
                <col style="width: 65%" />
              </colgroup>
              <tbody>
                <tr>
                  <th>Converted SOH</th>
                  <td>{{ car_info[3].bat_soh }}</td>
                </tr>
                <tr>
                  <th>Cumulative Usage</th>
                  <td>{{ car_info[3].purchase_date }}</td>
                </tr>
                <tr>
                  <th>Cumulative Mileage</th>
                  <td>{{ car_info[3].car_odo_meter }}</td>
                </tr>
                <tr>
                  <th>Cumulative Discharge</th>
                  <td>{{ car_info[3].bat_acc_discharge }}</td>
                </tr>
                <tr>
                  <th>Est. Remaining Life</th>
                  <td>{{ car_info[3].warranty_remain }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import anychart from 'anychart'
export default {
  name: 'GradeStatusPopup1',

  data () {
    return {
      popup_flag: false,
          popup_car_number: 0,
      car_info: [
        {
          soc: '',
          odo_meter: '',
          career: '',
          rapid: '',
          temperature: '',
        },
        {
          soc: '',
          odo_meter: '',
          career: '',
          rapid: '',
          temperature: '',
        },
        {
          production_date: '',
          bat_type: '',
          bat_capacity: '',
          bat_bms: '',
        },
        {
          bat_soh: '',
          purchase_date: '',
          car_odo_meter: '',
          bat_acc_discharge: '',
          warranty_remain: '',
        }
      ],
      chart_data: '',
      chart_data2: '',
    }
  },

  props: [
    'popupFlag',
    'popupCarNumber',
    'grade'
  ],

  watch: {
    popupFlag: function () {
      this.popup_flag = this.popupFlag
    },
    popupCarNumber: function () {
      this.popup_car_number = this.popupCarNumber
      this.get_driving_data();
      this.get_chart_data();
    }
  },

  mounted () {
    this.popup_flag = this.popupFlag;
    this.popup_car_number = this.popupCarNumber;
  },

  methods: {
    setPopupCloseFlag () {
      this.popup_flag = false;
      this.$emit('setPopupCloseFlag', this.popup_flag);
    },
    getGradeReportIcon (grade) {
      let result = null
      switch (grade) {
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          result = require(`@/assets/images/svg/status-report-badge-${grade}.svg`);
          break;
        default:
          result = require(`@/assets/images/svg/status-report-badge-5.svg`);
          break;
      }
      return result;
    },
    getGradeReportColor (grade) {
      let color = null;
      switch (grade) {
        case 1:
          color = "#72caf2"
          break;
        case 2:
          color = "#72BEA8"
          break;
        case 3:
          color = "#EFCA5E"
          break;
        case 4:
          color = "#F0BF82"
          break;
        case 5:
          color = "#E78E85"
          break;
        default:
          color = "#000"
          break;
      }

      return color;
    },

    //차량 상세 평가 비교 데이터 조회
    get_driving_data(){
      var post_data = {car_number: this.popup_car_number, group_id: this.$store.getters.getGroupId}
      this.$axios.post('/api/grade_popup_get_driving_data', post_data).then(res => {
        var array = new Array();
        array[0] = res.data.result[0];
        array[1] = res.data.result[1];
        array[2] = res.data.result[2];
        array[3] = res.data.result[3];
        this.car_info = array;
      });
    },
    
    get_chart_data: function(){
      // 데이터 가져오기
      var post_data = {car_number: this.popup_car_number, group_id: this.$store.getters.getGroupId}
      this.$axios.post('/api/grade_popup_get_chart_data', post_data).then(res => {
        var route_data = res.data.result[0];
        var car_data = res.data.result[1];

        // 노선 데이터
        var arr = [];
        for(var i=0;i<route_data.length;i++){
          var temp_arr = [];
          temp_arr.push(route_data[i]['car_end_odo_meter']);
          temp_arr.push(route_data[i]['bat_soh']);

          arr.push(temp_arr);
        }

        // 실제 데이턴
      var arr2 = [];
        for(var j=0;j<car_data.length;j++){
          var temp_arr2 = [];
          temp_arr2.push(car_data[j]['car_end_odo_meter']);
          temp_arr2.push(car_data[j]['bat_soh']);

          arr2.push(temp_arr2);
        }

        this.chart_data = arr;
        this.chart_data2 = arr2;
        this.anychart2();
      });
      //
    },
    
    // 누적거리에 따른 soh 차트
    anychart2: function () {
      this.$refs.anychart2.innerHTML = "";
      anychart.onDocumentReady(() => {
        var chart = anychart.scatter();

        // turn on chart animation
        chart.animation(true);

        // set chart title
        //chart.title('System interruptions');

        /*chart.xScale().minimum(0).maximum(250000).ticks({ interval: 50000 });
        chart.yScale().minimum(40).maximum(100).ticks({ interval: 20 });*/
        
        chart.yScale().minimum(40).maximum(100).ticks({ interval: 20 });

        chart.yAxis().title('Battery SOH');
        chart
          .xAxis()
          .title('Mileage')
          .drawFirstLabel(false)
          .drawLastLabel(false);

        chart.interactivity().hoverMode('by-spot').spotRadius(30);

        chart.tooltip().displayMode('union');

        // The data used in this sample can be obtained from the CDN
        // https://cdn.anychart.com/samples/scatter-charts/combination-of-line-and-marker-charts/data.js
        var marker = chart.marker(this.chart_data);
        
        marker.type('triangle-up').size(4);
        marker
          .hovered()
          .size(7)
          .fill('gold')
          .stroke(anychart.color.darken('gold'));
        marker
          .tooltip()
          .hAlign('start')
          .format(function () {
          return (
            'Battery SOH: ' +
            this.value +
            ' %\nMileage: ' +
            this.x +
            ' km'
          );
          });

        // The data used in this sample can be obtained from the CDN
        // https://cdn.anychart.com/samples/scatter-charts/combination-of-line-and-marker-charts/data.js
        chart.line(this.chart_data2);
        //chart.line(this.getLineData()); 

        //워터마커 제거
        anychart.licenseKey("4dream-8254134a-23a23715");
        var credits = chart.credits();
        credits.enabled(false);
        
        // turn on chart animation
        chart.animation(true);
        
        // grid set
        chart.yGrid(true);
        
        // set container id for the chart
        chart.container('anychart2');
        // initiate chart drawing
        chart.draw();
      });
    },
  }
}


</script>

<style lang="scss" scoped>
.status-popup {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: none;
  &.active {
    display: block;
  }

  &__bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.4);
    @include mobile {
      display: none;
    }
  }

  &__container {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 1300px;
    height: auto;
    background: #f2f2f2;
    border: 1px solid #979797;
    border-radius: 6px;
    @include mobile {
      width: 100%;
      height: 100%;
      padding: 10px;
      overflow: auto;
      border: none;
      border-radius: none;
    }
  }

  &__title {
    font-size: 22px;
    height: 61px;
    width: 100%;
    background: #077f80;
    color: #fff;
    padding-left: 33px;
    font-weight: 600;
    display: flex;
    align-items: center;
    border-radius: 6px 6px 0 0;
    @include mobile {
      position: absolute;
      top: 20px;
      left: 20px;
      font-size: 18px;
      font-weight: 700;
      background: transparent;
      color: #077f80;
      display: inline-block;
      height: auto;
      width: auto;
      padding-left: 0;
      &::after {
        content: '';
        display: block;
        position: absolute;
        left: 0;
        bottom: -4px;
        background: #077f80;
        width: 100%;
        height: 2px;
      }
    }
  }

  &__contents {
    display: grid;
    grid-template-columns: 1fr 2fr 1.5fr;
    gap: 25px;
    padding: 25px;
    @include mobile {
      grid-template-columns: 1fr;
      padding: 0;
      gap: 10px;
    }

    >div {
      border: 1px solid #979797;
      border-radius: 6px;
      padding: 16px 24px;
      background: #fff;
      @include mobile {
        width: 100%;
        padding: 10px;
      }
    }
    &__icon {
      border: none !important;
      background: none !important;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      @include mobile {
        border: 1px solid #979797 !important;
        background: #fff !important;
        flex-direction: row;
        padding-top: 50px !important;
        order: 1;
      }
      img {
        width: 193px;
        height: auto;
        @include mobile {
          width: 150px;
        }
      }
      p {
        font-size: 20px;
        font-weight: 700;
        span {
          font-size: 60px;
          font-weight: 700;
        }
      }
    }
    &__box1 {
      @include mobile {
        order: 2;
      }
      section {
        font-size: 13px;
        display: flex;
        text-align: center;
        >ul {
          border-radius: 6px;
          &:not(.desc) li:first-child {
            position: absolute;
            top: -27px;
            left: 0;
            width: 100%;
            padding: 0;
            text-align: center;
            font-weight: 600;
          }
        }
        .desc {
          background: #1c5660;
          color: #fff;
          padding: 0 8px;
          width: 50%;
          li {
            padding: 8px 0px 8px 2px;
            border-bottom: 1px solid #fff;
            &:last-child {
              border: none;
            }
            p {
              display: flex;
              justify-content: space-between;
              align-items: center;
              font-weight: 300;
              b {
                display: block;
                padding: 4px 9px;
                border-radius: 6px;
                background: #fff;
                &.safe {color: #08a077;}
                &.care {color: #e27000;}
                &.warn {color: #df0000;}
              }
            }
          }
        }
        .average {
          margin: 0 14px;
          background: #b3ced3;
          position: relative;
          width: calc((50% - 42px) / 2);
          li {
            padding: 12px 0;
            line-height: 16px;
          }
          &::after {
            content: '';
            display: block;
            position: absolute;
            width: 1px;
            height: 100%;
            background: #5c5c5c;
            top: 0;
            right: -16px;
          }
        }
        .target {
          margin: 0 14px;
          margin-right: 0;
          background: #f1d0ca;
          position: relative;
          width: calc((50% - 42px) / 2);
          li {
            padding: 12px 0;
            line-height: 16px;
          }
        }
      }
    }
    &__box2 {
      @include mobile {
        order: 3;
      }
    }
    &__box3 {
      grid-column: 1/3;
      @include mobile {
        grid-column: auto;
        order: 2;
        height: 250px;
        padding-bottom: 0 !important;
      }
    }
    &__box4 {
      @include mobile {
        order: 4;
      }
    }
    &__title {
      font-size: 22px;
      font-weight: 700;
      color: #077f80;
      position: relative;
      display: inline-block;
      margin-bottom: 25px;
      @include mobile {
        font-size: 18px;
      }
      &::after {
        content: '';
        display: block;
        position: absolute;
        left: 0;
        bottom: -4px;
        background: #077f80;
        width: 100%;
        height: 2px;
      }
    }
    &__table {
      width: 100%;
      border-radius: 6px;
      border: 1px solid #343434;
      overflow: hidden;
      table {
        width: 100%;
        text-align: center;
        font-size: 14px;
        color: #343434;
      }
      tr {
        border-bottom: 1px solid #343434;
        height: 49px;
        @include mobile {
          height: 40px;
        }
        &:last-child {
          border-bottom: none;
        }
      }
      th {
        border-right: 1px solid #343434;
        background: #cbece7;
        font-weight: 600;
      }
      td {
        font-weight: 300;
      }
    }
  }

  &__close {
    position: absolute;
    top: 0;
    right: 0;
    width: 75px;
    height: 61px;
    button {
      width: 100%;
      height: 100%;
      background: url('~@/assets/images/icon/close-white.png') no-repeat center;
    }
  }
}
</style>